import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { Subscription } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { EoiSectionsComponent } from '../eoi-sections.component';

@Component({
  selector: 'app-work-packages-selection',
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './work-packages-selection.component.html',
  styleUrl: './work-packages-selection.component.css',
})
export class WorkPackagesSelectionComponent implements OnInit, OnChanges {
  @Output() responseEmitter = new EventEmitter<any>();
  @Input() currentEOISavedData: any = [];

  // TODO: this should be removed
  private subscription: Subscription = new Subscription();

  projectIdNew: string;
  eoiData: any;
  selectAllChecked = false; // To track the "Select All" checkbox state
  projectName: string;

  eoiTitleControl = new FormControl(null, Validators.required);
  selectedWorkPackagesControl = new FormControl(null);
  additionalInfoControl = new FormControl();

  constructor(
    private toast: NgToastService,
    private tenderingService: TenderingService,
    private GetProjectIdService: GetProjectIdService,
    private EoiSectionsComponent: EoiSectionsComponent
  ) {}

  ngOnInit(): void {
    this.projectName = localStorage.getItem('project-name');
    this.fetchDataForEOI();

    // TODO: this should be removed
    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
      this.fetchDataForEOI();
    });

    this.isEOISavedDataExist();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentEOISavedData']) {
      this.isEOISavedDataExist();
    }
  }

  isEOISavedDataExist() {
    if (this.currentEOISavedData?.eoiData) {
      const savedWPData =
        this.currentEOISavedData.eoiData.selected_work_packages.map(
          (wp: any) => ({
            id: wp?.p_w_p_id,
            name: wp?.name,
          })
        ) || [];

      // Set values in FormControl
      this.selectedWorkPackagesControl.setValue(savedWPData);

      savedWPData.forEach((wp) => {
        this.isSelected(wp?.id);
      });
      // Pre-select checkboxes for already selected work packages
      this.selectAllChecked =
        savedWPData.length === this.eoiData?.projectWPDetails.length;
      this.eoiTitleControl.setValue(this.currentEOISavedData.eoiData?.name);
      this.additionalInfoControl.setValue(
        this.currentEOISavedData.eoiData?.work_packages_details
      );
    }
  }

  toggleWorkPackageSelection(event: Event, workpackage: any): void {
    const checkbox = event.target as HTMLInputElement;
    const currentValue = this.selectedWorkPackagesControl.value || []; // Get current value as an array

    if (checkbox.checked) {
      // Add the selected work package to the array
      this.selectedWorkPackagesControl.setValue([
        ...currentValue,
        {
          id: workpackage?.id,
          name: workpackage?.work_package?.name,
        },
      ]);
    } else {
      // Remove the work package from the array
      const updatedValue = currentValue.filter(
        (wp: any) => wp?.id !== workpackage?.id
      );
      this.selectedWorkPackagesControl.setValue(updatedValue);
    }

    this.selectedWorkPackagesControl.updateValueAndValidity(); // Ensure the control reflects the updated value
  }

  isSelected(id: number): boolean {
    const selectedPackages = this.selectedWorkPackagesControl.value || []; // Get the value of the FormControl
    const result = selectedPackages.some((wp: any) => wp?.id === id);
    return result;
  }

  selectAllWorkPackages(): void {
    this.selectAllChecked = !this.selectAllChecked; // Toggle the select-all state

    if (this.selectAllChecked) {
      // Select all work packages
      const allWorkPackages =
        this.eoiData?.projectWPDetails?.map((workpackage: any) => ({
          id: workpackage?.id,
          name: workpackage?.work_package?.name,
        })) || [];
      this.selectedWorkPackagesControl.setValue(allWorkPackages);
    } else {
      // Deselect all work packages
      this.selectedWorkPackagesControl.setValue([]);
    }
  }

  fetchDataForEOI() {
    this.tenderingService.getInitiatiationData().subscribe({
      next: (response: any) => {
        this.eoiData = response.data;
      },
      error: (error: any) => {
        console.error('Failed to fetch EOI initiation data:', error);
      },
    });
  }

  moveToPreviousStep() {
    // TODO: rename this to parent component
    this.EoiSectionsComponent.previousStep();
  }

  prepareEOIStep1Data() {
    const data = {
      eoi_name: this.eoiTitleControl.value,
      description: this.additionalInfoControl.value,
      eoi_id: this.currentEOISavedData?.eoiData?.id ?? null,
      p_w_p: this.selectedWorkPackagesControl.value,
    };

    return data;
  }

  validateData(): boolean {
    this.eoiTitleControl.markAsTouched();
    // this.selectedWorkPackagesControl.markAsTouched();

    if (this.eoiTitleControl.invalid) {
      return false;
    }
    return true;
  }

  moveToNextStep() {
    if (!this.validateData()) {
      return;
    }

    const dataToSubmit = this.prepareEOIStep1Data();
    console.log('The packages data saving is:', dataToSubmit);
    this.tenderingService.storeEOIStep1Data(dataToSubmit).subscribe({
      next: (response: any) => {
        this.toast.success('Work Packages Submitted submitted', 'SUCCESS');
        this.responseEmitter.emit({
          eoiId: response?.data?.eoi?.id,
          projectId: response?.data?.eoi?.project_id,
          updateWorkPackages: response?.data,
        });

        // TODO: rename this to parent component
        this.EoiSectionsComponent.nextStep();
      },
      error: (error: any) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }

  handleBack() {
    // TODO: rename this to parent component
    this.EoiSectionsComponent.previousStep();
  }
}
